import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.parse-int.js";
import { getClient } from '../currentScopes.js';
import { DEBUG_BUILD } from '../debug-build.js';
import '../tracing/errors.js';
import { getGlobalSingleton } from '../utils-hoist/worldwide.js';
import '../utils-hoist/debug-build.js';
import { logger } from '../utils-hoist/logger.js';
import { timestampInSeconds } from '../utils-hoist/time.js';
import { getActiveSpan, getRootSpan, spanToJSON } from '../utils/spanUtils.js';
import { startSpanManual } from '../tracing/trace.js';
import { handleCallbackErrors } from '../utils/handleCallbackErrors.js';
import { COUNTER_METRIC_TYPE, DISTRIBUTION_METRIC_TYPE, SET_METRIC_TYPE, GAUGE_METRIC_TYPE } from './constants.js';

/**
 * Gets the metrics aggregator for a given client.
 * @param client The client for which to get the metrics aggregator.
 * @param Aggregator Optional metrics aggregator class to use to create an aggregator if one does not exist.
 */
function getMetricsAggregatorForClient(client, Aggregator) {
  var globalMetricsAggregators = getGlobalSingleton('globalMetricsAggregators', function () {
    return new WeakMap();
  });
  var aggregator = globalMetricsAggregators.get(client);
  if (aggregator) {
    return aggregator;
  }
  var newAggregator = new Aggregator(client);
  client.on('flush', function () {
    return newAggregator.flush();
  });
  client.on('close', function () {
    return newAggregator.close();
  });
  globalMetricsAggregators.set(client, newAggregator);
  return newAggregator;
}
function addToMetricsAggregator(Aggregator, metricType, name, value) {
  var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var client = data.client || getClient();
  if (!client) {
    return;
  }
  var span = getActiveSpan();
  var rootSpan = span ? getRootSpan(span) : undefined;
  var transactionName = rootSpan && spanToJSON(rootSpan).description;
  var unit = data.unit,
    tags = data.tags,
    timestamp = data.timestamp;
  var _client$getOptions = client.getOptions(),
    release = _client$getOptions.release,
    environment = _client$getOptions.environment;
  var metricTags = {};
  if (release) {
    metricTags.release = release;
  }
  if (environment) {
    metricTags.environment = environment;
  }
  if (transactionName) {
    metricTags.transaction = transactionName;
  }
  DEBUG_BUILD && logger.log("Adding value of ".concat(value, " to ").concat(metricType, " metric ").concat(name));
  var aggregator = getMetricsAggregatorForClient(client, Aggregator);
  aggregator.add(metricType, name, value, unit, _objectSpread(_objectSpread({}, metricTags), tags), timestamp);
}

/**
 * Adds a value to a counter metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */
function increment(aggregator, name) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var data = arguments.length > 3 ? arguments[3] : undefined;
  addToMetricsAggregator(aggregator, COUNTER_METRIC_TYPE, name, ensureNumber(value), data);
}

/**
 * Adds a value to a distribution metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */
function distribution(aggregator, name, value, data) {
  addToMetricsAggregator(aggregator, DISTRIBUTION_METRIC_TYPE, name, ensureNumber(value), data);
}

/**
 * Adds a timing metric.
 * The metric is added as a distribution metric.
 *
 * You can either directly capture a numeric `value`, or wrap a callback function in `timing`.
 * In the latter case, the duration of the callback execution will be captured as a span & a metric.
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */
function timing(aggregator, name, value) {
  var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'second';
  var data = arguments.length > 4 ? arguments[4] : undefined;
  // callback form
  if (typeof value === 'function') {
    var startTime = timestampInSeconds();
    return startSpanManual({
      op: 'metrics.timing',
      name: name,
      startTime: startTime,
      onlyIfParent: true
    }, function (span) {
      return handleCallbackErrors(function () {
        return value();
      }, function () {
        // no special error handling necessary
      }, function () {
        var endTime = timestampInSeconds();
        var timeDiff = endTime - startTime;
        // eslint-disable-next-line deprecation/deprecation
        distribution(aggregator, name, timeDiff, _objectSpread(_objectSpread({}, data), {}, {
          unit: 'second'
        }));
        span.end(endTime);
      });
    });
  }

  // value form
  // eslint-disable-next-line deprecation/deprecation
  distribution(aggregator, name, value, _objectSpread(_objectSpread({}, data), {}, {
    unit: unit
  }));
}

/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */
function set(aggregator, name, value, data) {
  addToMetricsAggregator(aggregator, SET_METRIC_TYPE, name, value, data);
}

/**
 * Adds a value to a gauge metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */
function gauge(aggregator, name, value, data) {
  addToMetricsAggregator(aggregator, GAUGE_METRIC_TYPE, name, ensureNumber(value), data);
}

/**
 * The metrics API is used to capture custom metrics in Sentry.
 *
 * @deprecated The Sentry metrics beta has ended. This export will be removed in a future release.
 */
var metrics = {
  increment: increment,
  distribution: distribution,
  set: set,
  gauge: gauge,
  timing: timing,
  /**
   * @ignore This is for internal use only.
   */
  getMetricsAggregatorForClient: getMetricsAggregatorForClient
};

// Although this is typed to be a number, we try to handle strings as well here
function ensureNumber(number) {
  return typeof number === 'string' ? parseInt(number) : number;
}
export { metrics };